import '@ta-interaktiv/semantic-ui/semantic/dist/components/form.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'

import { AnswerButtons } from 'components/answerButtons'
import * as React from 'react'
import { Age } from 'types/age'
import { Education } from 'types/education'
import { Gender } from 'types/gender'
import { IDemographics } from 'types/IDemographics'
import Dropdown from 'components/dropdown'

interface IDemographicsHandlers {
  handleAgeUpdate: (age: Age) => void
  handleGenderUpdate: (gender: Gender) => void
  handleEducationUpdate: (education: Education) => void
}

export function Demographics({
  age,
  gender,
  education,
  handleAgeUpdate,
  handleGenderUpdate,
  handleEducationUpdate
}: Partial<IDemographics> & IDemographicsHandlers) {
  return (
    <div style={{ zIndex: 100 }}>
      <h3 className='ui purple header'>Demographische Angaben</h3>
      <div className='ui form vertical segment'>
        <div className='ui grid'>
          <div className='stackable doubling three column row'>
            <div className='column'>
              <div className='grouped fields' id={'age'}>
                <label htmlFor='age'>Alter</label>
                <Dropdown
                  changeHandler={val => handleAgeUpdate(val as Age)}
                  options={Object.values(Age).map(age => ({
                    value: age,
                    text: age
                  }))}
                  currentValue={age}
                />
              </div>
            </div>
            <div className='column'>
              <div className='grouped fields' id={'gender'}>
                <label htmlFor='gender'>Geschlecht</label>
                <Dropdown
                  changeHandler={val => handleGenderUpdate(val as Gender)}
                  options={Object.values(Gender).map(gender => ({
                    value: gender,
                    text: gender
                  }))}
                  currentValue={gender}
                />
              </div>
            </div>
            <div className='column'>
              <div className='grouped fields'>
                <label htmlFor=''>Ausbildung</label>
                <Dropdown
                  changeHandler={val => handleEducationUpdate(val as Education)}
                  options={Object.values(Education).map(edu => ({
                    value: edu,
                    text: edu
                  }))}
                  currentValue={education}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
